import React from 'react';
import { Button, Icon, Message, Modal, Table } from 'semantic-ui-react';
import { format } from 'date-fns';
import SmoothModal from './components/SmoothModal';
import colors from '../utils/colors';

const names = (ids, dict) => ids.map(id => dict[id] ?? 'Unknown').join(', ');

/** Preview of "Send confirmation texts": everyone in notify roles who hasn't been asked to confirm yet. */
export default function ServicesNotifyPopup({ open, results, monthLabel, memberNamesDict, sending, onClose, onConfirm }) {
	const withTexts = results.filter(r => r.texted.length > 0 || r.blockouts?.length > 0);
	const total = withTexts.reduce((n, r) => n + r.texted.length, 0);
	const noPhone = [...new Set(results.flatMap(r => r.noPhone))];
	const blocked = results.filter(r => r.blockouts?.length > 0);

	return (
		<SmoothModal open={open} size='large' onClose={sending ? undefined : onClose} header={monthLabel ? `Send confirmation texts · ${monthLabel}` : 'Send confirmation texts'}>
			<Modal.Content scrolling>
				{withTexts.length === 0 ?
					<Message>Everyone in {monthLabel ? `${monthLabel}'s` : 'these'} upcoming services has already been asked to confirm. Nothing to send.</Message>
					:
					<>
						<p>These people are assigned but haven't been texted yet. Each gets one text asking them to confirm or decline. Nobody else on the event is texted{monthLabel ? `, and only ${monthLabel} services are included` : ''}.</p>
						<Table celled compact unstackable>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell>Service</Table.HeaderCell>
									<Table.HeaderCell>Role</Table.HeaderCell>
									<Table.HeaderCell>Will be texted</Table.HeaderCell>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{withTexts.map(r => r.roles.map((role, idx) =>
									<Table.Row key={`${r.key}_${role.roleId}`}>
										{idx === 0 &&
											<Table.Cell rowSpan={r.roles.length} verticalAlign='top'>
												<b>{r.label}</b>
												<div>{format(new Date(r.start), 'EEE, MMM d, h:mm a')}</div>
											</Table.Cell>
										}
										<Table.Cell verticalAlign='top'>{role.roleName}</Table.Cell>
										<Table.Cell verticalAlign='top'>{names(role.memberIds.filter(id => r.texted.includes(id)), memberNamesDict) || <span style={{ color: colors.midGray }}>no phone</span>}</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>
						</Table>
					</>
				}
				{blocked.length > 0 &&
					<Message warning>
						<Message.Header>Blockout conflicts</Message.Header>
						{blocked.map(r => <div key={r.key}>{r.label}, {r.day}: {names(r.blockouts, memberNamesDict)} marked themselves unavailable, so they will be marked declined instead of texted.</div>)}
					</Message>
				}
				{noPhone.length > 0 &&
					<div style={{ color: colors.darkGray, fontSize: 12 }}><Icon name='info circle' />No phone number, so no text: {names(noPhone, memberNamesDict)}</div>
				}
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={onClose} disabled={sending}>Cancel</Button>
				<Button primary disabled={withTexts.length === 0 || sending} loading={sending} onClick={onConfirm}>
					Send {total} text{total === 1 ? '' : 's'}
				</Button>
			</Modal.Actions>
		</SmoothModal>
	);
}
